import authClient from 'auth-client';
import { reportError } from 'helpers/error-reporting';

/**
 * The auth client `window.apc_auth` has an, uh, unpolished API, requiring
 * consumers to pass tokens back and forth. This wrapper smooths over the token passing
 * and makes the API a bit less verbose.
 *
 * All functions are wrapped so that they can be called without context from a saga
 */

export default function createAuthClient({ onError = reportError } = {}) {
  return {
    /**
     * @return {Promise(User)} user
     */
    login: () =>
      authClient.loginUser({ reportError: onError, storeToken: true }),
    /**
     * @return ???
     */
    logout: () => authClient.logoutUser({ reportError: onError }),
    /** */
    resetPassword: () => authClient.resetPassword(),
    /**
     * @return {string} JWT - API CLIENT ONLY
     */
    getToken: () => authClient.getCurrentCustomToken(),
    /**
     * @returns {*} JWT - The original Firebase token
     */
    getOriginalToken: () => authClient.getCurrentIdToken(),
    /**
     * @return {string} id - the current (real or spoofed) account id
     */
    getAccountId: async () => {
      const token = await authClient.getCurrentCustomToken();
      return authClient.getAccountFromToken(token);
    },
    /**
     * @return {string|null} id - the real id before spoofing, or null
     */
    getOriginalAccountId: async () => {
      const token = await authClient.getCurrentCustomToken();
      return authClient.getOriginalAccountFromToken(token);
    },
    /**
     * @return {string|null} uid - the real user id before spoofing, or null
     */
    getOriginalUserId: async () => {
      const token = await authClient.getCurrentCustomToken();
      return authClient.getOriginalUserFromToken(token);
    },
    /**
     * @return none
     */
    spoof: id => authClient.spoof(id),
    /**
     * @return none
     */
    despoof: () => authClient.despoof(),
    /**
     * @return {boolean} isSpoofing
     */
    isSpoofing: () => authClient.isSpoofing(),
    /**
     * @return none
     */
    switchAccount: id => authClient.switchAccount(id),
  };
}
